import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Computer = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/learning-app.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Facilities" breadEnd="Learning Approach" breadMid="Computer Lab" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h4 className="color-red">Computer</h4>
                            <div class="lab-heading mb-4">
                                <div class="lab-btn" id="mb-lab-btn"><span>Labs</span></div>
                                <ul class="labs-list">
                                    <li><a class="" href="/mathmatics">Mathematics</a></li>
                                    <li><a class="" href="/physics">Physics</a></li>
                                    <li><a class="" href="/biology">Biology</a></li>
                                    <li><a class="" href="/chemistry">Chemistry</a></li>
                                    <li><a class="" href="/language">Language</a></li>
                                    <li><a class="inc-tlink-active" href="/computer">Computer</a></li>
                                    <li><a class="" href="/robotics">Robotics</a></li>
                                    <li><a class="" href="/hands-on-studio">Hands On Studio</a></li>
                                    <li><a class="" href="/psychology">Psychology</a></li>
                                    <li><a class="" href="/counseling-sen">Counseling &amp; Sen </a></li>
                                </ul>
                            </div>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/computer-lab.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <p>Computers are undeniably the most significant means of education in the modern world and ICT inspired learning paves a thriving way for our learners to explore, unfold and pilot through the latest knowledge resources. Our Primary Wing provides our young learners with a spacious <b>ICT lab- ‘E-Dreamz’,</b> fully equipped with advanced infrastructure in terms of hardware and software befitting the requirements of the students and the faculty for learning, research and training initiatives. Each learner gets an exclusive system to operate and unearth the supreme joy of innovation whilst they exercise the classroom learning into practice. The IT curriculum for each grade amalgamates with the program of study across scholastic disciplines to inculcate inter-disciplinary learning along with the development of essential skills associated with data analysis, reasoning, problem solving and representation of information. We ensure to review and upgrade our curriculum in order to keep pace with the Global IT standards. ‘E-Dreamz’ also unfastens new horizons for our budding scientists by providing hands-on experience of <b>Robotics and Lego programming.</b></p>
                        </div>

                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Computer